import $ from "jquery";
import "slick-lightbox";
import "slick-slider";

export const gbdUI = {
    navtoggle() {
        $(".navbar-nav > li.has_subtree > a").on("click", function (event) {
            event.preventDefault();
            const $parent = $(this).parents('li');
            if ($parent.hasClass("opened")) {
                /* click on opened menu only closes */
                $parent.removeClass("opened");
                return;
            }
            $(".navbar-nav > li.has_subtree").removeClass("opened");
            $parent.addClass("opened");
        });
        /* close opened subnavs when clicking outside */
        $("body").on("click", (e) => {
            if ($(e.target).parents("#portal-globalnav").length > 0) {
                return;
            }
            $("#portal-globalnav > li.opened").removeClass("opened");
        });
    },

    init_loadmore() {
        const $contentcore = $('#content-core');
        const $contentlisting = $('.listingWrapper');
        const $pagination = $contentcore.find('.pagination');

        if (!$pagination.length) return;

        const $nxt_link = $('li.next a', $pagination);

        if (!$nxt_link.length) return;

        const url = $nxt_link.attr('href');
        const load_txt = `<a class="btn btn-outline-primary">
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
    <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
</svg></a>`;
        const $load_more = $('<div class="load-more" data-nexturl="' + url + '">' + load_txt + '</div>');

        $pagination.hide();
        $contentcore.append($load_more);

        $load_more.on('click', (e) => {
            e.preventDefault();
            var nxt_url = $(e.currentTarget).data('nexturl');
            $(e.currentTarget).html('<i class="fa fa-circle-o-notch fa-spin fa-2x fa-fw"></i>');
            $.ajax({
                url: nxt_url + "&ajax_load=1",
                success: function (html) {
                    var $html = $(html),
                        items = $html.find('.listingWrapper > .tileItem'),
                        $ajax_nxt_link = $html.find('#content-core .pagination li.next a');

                    $contentlisting.append(items);

                    if (!$ajax_nxt_link.length) {
                        $load_more.hide();
                    } else {
                        $load_more.data('nexturl', $ajax_nxt_link.attr('href'));
                        $load_more.html(load_txt);
                    }
                }
            });
        });
    },

    init_slick() {
        var time = 2;
        var isPause,
            tick,
            percentTime;

        const $slickSliderTile = $('.sliderTile .slider');
        $slickSliderTile.slick({
            draggable: true,
            adaptiveHeight: false,
            // dots: true,
            infinite: true,
            arrows: false,
            mobileFirst: true,
            pauseOnDotsHover: true,
            fade: true,
        });

        const $slickExistingContentSlider = $('.existingContentSlider .slider');
        $slickExistingContentSlider.slick({
            draggable: true,
            adaptiveHeight: false,
            // dots: true,
            infinite: true,
            arrows: false,
            mobileFirst: true,
            pauseOnDotsHover: true,
            fade: true,
        });

        const $slick = $('#slick-main .slider');
        $slick.slick({
            draggable: true,
            adaptiveHeight: false,
            // dots: true,
            infinite: true,
            arrows: false,
            asNavFor: '#slick-nav .slider',
            mobileFirst: true,
            pauseOnDotsHover: true,
            fade: true,
        });

        $('#slick-main .slider').slickLightbox({
            src: 'data-image-large',
            itemSelector: '.slide'
        });

        $('#slick-nav .slider').slickLightbox({
            src: 'data-image-large',
            itemSelector: '.slide'
        });

        $('#slick-nav .slider').slick({
            asNavFor: '#slick-main .slider',
            arrows: false,
            centerMode: true,
            centerPadding: '0px',
            dots: false,
            focusOnSelect: true,
            rows: 1,
            infinite: false,
        });


        const $bar = $('.slider-progress .progress');

        $('.slider-wrapper').on({
            mouseenter: function () {
                isPause = true;
            },
            mouseleave: function () {
                isPause = false;
            }
        })

        function startProgressbar() {
            resetProgressbar();
            percentTime = 0;
            isPause = false;
            tick = setInterval(interval, 20);
        }

        function interval() {
            if (isPause === false) {
                percentTime += 1 / (time + 0.1);
                $bar.css({
                    width: percentTime + "%"
                });
                if (percentTime >= 100) {
                    $slick.slick('slickNext');
                    $slickSliderTile.slick('slickNext');
                    $slickExistingContentSlider.slick('slickNext');
                    startProgressbar();
                }
            }
        }

        function resetProgressbar() {
            $bar.css({
                width: 0 + '%'
            });
            clearTimeout(tick);
        }

        startProgressbar();

    },


    init_ajax() {
        this.init_loadmore();
    },

    init() {

        this.navtoggle();
        this.init_slick();
        this.init_loadmore();

        // after collectionfilter updates
        $(document).on("loading-done.contentloader.patterns", this.init_loadmore);
    },

}
